<template>
    <div class="register-form">
        <div class="form-body">
            <div class="form-title">面辅料代购员入驻申请</div>
            <div class="form-desc">填写信息，一键入驻，开启接单增收之路</div>
            <div class="form">
                <div class="form-item-col-2">
                    <div class="form-item-input">
                        <div class="form-item-label required">您的姓名</div>
                        <div class="form-item-value">
                            <input type="text" v-model="form_data.name" placeholder="请输入您的姓名" />
                        </div>
                    </div>
                    <div class="form-item-input">
                        <div class="form-item-label required">手机号码</div>
                        <div class="form-item-value">
                            <input type="text" v-model="form_data.mobile" placeholder="请输入您的手机号码" />
                        </div>
                    </div>
                </div>
                <div class="form-item-col-1">
                    <div class="form-item-input">
                        <div class="form-item-label ">身份证</div>
                        <div class="form-item-value-upload">
                            <Upload action="/" :before-upload="(file)=>onBeforeUpload(file,'front')" :data="{dir:'template'}" >
                                <div class="upload-item">
                                    <div class="img-item">
                                        <img v-if="form_data.id_card.id_front" src="@/assets/images/icon-close-circle.png" alt="" class="delete-ico" @click.stop="onDeleteImg('front')" />
                                        <img :src="form_data.id_card.id_front || require('@/assets/images/bg-id-card-front.png')" alt="" />
                                    </div>
                                    <div class="item-title">上传身份证正面(头像面)</div>
                                </div>
                            </Upload>
                            <Upload action="/" :before-upload="(file)=>onBeforeUpload(file,'back')" :data="{dir:'template'}" >
                                <div class="upload-item">
                                    <div class="img-item">
                                        <img v-if="form_data.id_card.id_back" src="@/assets/images/icon-close-circle.png" alt="" class="delete-ico" @click.stop="onDeleteImg('back')" />
                                        <img :src="form_data.id_card.id_back || require('@/assets/images/bg-id-card-back.png')" alt="" />
                                    </div>
                                    <div class="item-title">上传身份证反面(国徽面)</div>
                                </div>
                            </Upload>
                            <ul>
                                <li>支持JPG/PNG/JPEG格式的图片</li>
                                <li>图片大小≤3M</li>
                                <li>确保身份证有效,头像文字清晰,四角完整,无反光无遮挡</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="form-item-col-2">
                    <div class="form-item-input">
                        <div class="form-item-label required">
                            所在地区
                        </div>
                        <div class="form-item-value">
                            <Cascader placeholder="请选择" size="large" :data="region" v-model="area" style="height:100%;" @on-change="onAreaChange"> 
                            </Cascader>
                        </div>
                    </div>
                     <div class="form-item-input">
                        <div class="form-item-label required">从业年限</div>
                        <div class="form-item-value">
                            <Select placeholder="请选择" v-model="form_data.work_year" size="large" style="height:100%;">
                                <Option v-for="item in 30" :key="item" :value="item">{{item}}年</Option>
                            </Select>
                        </div>
                    </div>
                </div>
                <div class="form-item-col-1">
                    <div class="form-item-input">
                        <div class="form-item-label-with-remark">
                            <div class="required">擅长品类</div>
                            <div class="remark">(可多选)</div>
                        </div>
                        <CheckboxGroup v-model="form_data.product_category" class="form-item-value-checkbox"> 
                            <div v-for="(item,index) in category_list" :key="index" class="checkbox-item" :title="item.name">
                                <Checkbox :label="item.id">{{item.name}}</Checkbox>
                            </div>
                        </CheckboxGroup>
                    </div>
                </div>
                <div class="form-item-col-1">
                    <div class="form-item-input">
                        <div class="form-item-label ">常驻市场</div>
                        <div class="form-item-value">
                            <input type="text" v-model="form_data.market" placeholder="例如:广州中大布料市场、绍兴柯桥轻纺城、石狮服装城面料市场、江苏苏州盛泽中国东方丝绸市场等" />
                        </div>
                        
                    </div>
                </div>
                <div class="form-item-col-1">
                    <div class="form-item-input">
                        <div class="form-item-label ">个人介绍</div>
                        <div class="form-item-value" style="height:150px;">
                            <textarea type="text" style="padding-top:14px;" v-model="form_data.introduction" placeholder="请简要介绍您的代购优势、服务范围、合作品牌等，提升您的接单率" />
                        </div>
                    </div>
                </div>
                <div class="form-item-col-1">
                    <div class="form-item-input">
                        <div class="form-item-label ">其他资质证明（可选）</div>
                        <Upload class="w100"  type="drag"  :show-upload-list="false" action="/" :before-upload="(file)=>onBeforeUpload(file,'files')" :data="{dir:'template'}" >
                            <div class="form-item-upload">
                                <img src="@/assets/images/procurement/icon-upload.png" alt="" class="upload-ico" />
                                <div class="text-666 margin-top-10">点击上传或拖拽文件至此处</div>
                                <div class="text-999 margin-top-10 text-12">可上传营业执照、行业认证等，支持JPG、PNG、PDF等格式</div>
                            </div>
                        </Upload>
                        <div class="file-box">
                            <div class="file-item" v-for="(item,index) in form_data.files" :key="index">
                                <img v-if="util.test_image(item.raw_name)" :src="item.raw" :alt="item.raw_name" class="img" style="object-fit:contain;" />
                                <img v-else :src="util.get_image_icon(item.raw_name)" :alt="item.raw_name" :title="item.raw_name" class="img" style="object-fit:contain">
                                <img @click="deleteImage(index)" src="@/assets/images/icon-close-circle-black.png" alt="" class="remove-icon">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Checkbox v-model="agree" class="form-agree">我已阅读并同意<div @click="onServiceRuleClick('procurementAgreement')">《面辅料代购服务协议》</div>和<div @click="onServiceRuleClick('procurementPrivacy')">《隐私政策》</div></Checkbox>
            <div class="form-submit">
                <div :class="['submit-btn',{disabled:!submitDisabled}]" @click="onSubmit">提交</div>
            </div>
        </div>
        <popup :show.sync="is_popup_show" width="680px" height="520px" @on-close="is_popup_show=false">
			<div class="agree-content">
				<div v-html="setting[agree_type]"></div>
			</div>
		</popup>
    </div>
</template>
<script>
import { categoryList, ProcurementRegister, RegisterCheck } from '@/api/procurement';
import Popup from '@/components/Popup';
import { uploadFileToOSS } from "@/utils/oss";
import region from "@/utils/region.js";
import util from "@/utils/util";
import { mapState } from 'vuex';
export default{
    components:{
        Popup
    },
    data(){
        return{
            util,
            region,
            form_data:{
                mobile:'',
                product_category:[],
                name:'',
                province:'',
                city:'',
                zone:'',
                work_year:'',
                files:[],
                market:'',
                introduction:'',
                id_card:{
                    id_front:'',
                    id_back:''
                }
            },
            agree:false,
            area:[],
            category_list:[],
            is_popup_show:false,
            agree_type:''
        }
    },
    watch:{
        'form_data.category'(news,olds){
            console.log('news',news,'olds',olds);
        }
    },
    computed:{
        ...mapState({
            setting: (state) => state.setting,
            userInfo:(state)=>state.userInfo
        }),
       
        submitDisabled(){
            return this.form_data.name && 
           this.form_data.mobile &&    
           this.form_data.product_category.length > 0 && 
           this.form_data.province && 
           this.form_data.city && 
           this.form_data.zone
           
        },
    },
    mounted(){
        this.getCheckInfo()
        this.onGetProductCateList();
        
    },
    methods:{
        async getCheckInfo(){
            try{
                const {code,data} = await RegisterCheck();
                this.form_data = data;
            }catch(e){
                console.log('err',e);
            }
        },
        onAreaChange(value){ 
            console.log('value',value);
            this.$set(this.form_data,'province',value[0]);
            this.$set(this.form_data,'city',value[1]);
            this.$set(this.form_data,'zone',value[2]);
        },
        async onGetProductCateList(){
            try{
                const {data} = await categoryList();
                this.category_list = data;
                // console.log('data->cate',data);
            }catch(e){
                console.log('err->cate',e);
            }
        },
        onDeleteImg(type){
            if(type === 'front'){
                this.form_data.id_card.id_front = '';
            }else{
                this.form_data.id_card.id_back = '';
            }
        },
        deleteImage(index){
            this.form_data.files.splice(index,1);
        },
        async onBeforeUpload(file,field) {
            console.log("file-before", file,field);
            try {
                const url = await uploadFileToOSS(file, "template");
                    switch(field){
                        case 'front':
                            this.form_data.id_card.id_front = url
                            break;
                        case 'back':
                            this.form_data.id_card.id_back = url
                            break;
                        
                        case 'files':
                            this.form_data.files.push({raw:url,raw_name:file.name});
                            break;
                        
                    }
                    console.log('url==>',this.form_data.id_card);

            } catch (err) {
                this.$layer.msg(`上传失败==>：${file.name}`);
            }
            return false;
        },
        async onSubmit(){
            try{
                console.log('form_data',this.form_data);
                if(!this.agree){
                    this.$layer.msg('请先阅读并同意面辅料代购服务协议和隐私政策');
                    return;
                }
                if(!this.submitDisabled){
                    this.$layer.msg('请填写完整信息');
                    return;
                }
                const {code,msg} = await ProcurementRegister(this.form_data);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('申请成功');
                this.$router.push({name:'ProcurementResult',query:{type:'apply'}})
            }catch(e){
                console.log('err-apply-pm',e);
                this.$layer.msg(e.msg);
            }
        },
        onServiceRuleClick(type){
            this.agree_type = type;
            this.is_popup_show = true;
        }
    }
}
</script>
<style lang="scss" scoped>
.register-form{
    width:100%;
    min-height:100vh;
    background:#f5f9fc;
    display:flex;
    justify-content:center;
    padding-bottom:80px;
    user-select: none;
    .form-body{
        width:100%;
        max-width:1000px;
        margin-top:28px;
        background:#fff;
        border-radius:10px;
        box-shadow:0px 0px 8px 4px rgba(1,32,55,0.05);
        .form-title{
            width:100%;
            text-align:center;
            color:#333;
            font-weight:bold;
            font-size:28px;
            margin-top:30px;
        }
        .form-desc{
            margin-top:8px;
            text-align:center;
            width:100%;
            color:#666;
            font-size:14px;
            padding-bottom:24px;
            border-bottom:1px solid #ebebeb;
        }
        .form{
            width:100%;
            padding:0 50px;
            margin-top:28px;
            .form-item-input{
                flex:1;
                display:flex;
                flex-direction:column;
                row-gap:16px;
                margin-bottom:32px;
                .form-item-label{
                    color:#333;
                    font-size:14px;
                    &.required::after{
                        content:"*";
                        color:red;
                    }
                }
                .form-item-label-with-remark{
                    color:#333;
                    font-size:14px;
                    display:flex;
                    align-items:center;
                    column-gap:5px;
                    .required::after{
                        content:"*";
                        color: red;
                    }
                    .remark{
                        color:#666;
                    }
                }
                .file-box{
                    display: flex;
                    flex-wrap: wrap;
                    column-gap:10px;
                    margin-top: 16px;
                    .file-item{
                        width: 172px;
                        height: 116px;
                        border-radius: 4px 4px 4px 4px;
                        border: 1px solid #E3E3E3;
                        display: flex;
                        align-content: center;
                        position: relative;
                        .img{
                         height: 116rpx;
                        }
                        .remove-icon{
                            width:22px;
                            height:22px;
                            position:absolute;
                            top:5px;
                            right:5px;
                        }
                    }
                }
                .form-item-upload{
                    width:100%;
                    height: 150px;
                    background: #F8F9FB;
                    border-radius: 10px 10px 10px 10px;
                    border: 1px solid #B3B3B3;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    .upload-ico{
                        width: 24px;
                        height: 24px;
                    }
                }
                .form-item-value{
                    width:100%;
                    height:50px;
                    border:1px solid #e3e3e3;
                    border-radius:8px;
                    overflow:hidden;
                    input,textarea{
                        border:none;
                        outline:none;
                        width:100%;
                        height:100%;
                        padding:0 16px;
                        &:focus{
                            border:none;
                            border-color:transparent !important;
                        }
                    }
                    ::v-deep .ivu-select-selection{
                        height:100%;
                        display:flex;
                        align-items:center;
                        border:none;
                    }
                    ::v-deep .ivu-select-placeholder{
                        color:#999;
                    }
                    ::v-deep .ivu-cascader-rel{
                        height:100%;
                        border:none;
                        outline:none;
                        display:flex;
                        align-items:center;
                    }
                    ::v-deep .ivu-cascader{
                        height:100%;
                        display:flex;
                        align-items:center;
                        border:none;
                    }
                    ::v-deep .ivu-input{
                        border:none;
                        outline:none;
                        height:100%;
                        &:focus{
                            border-color:transparent !important;
                            box-shadow:none !important;
                            -webkit-box-shadow:none !important;
                        }
                    }
                }
                .form-item-value-upload{
                    width:100%;
                    display:flex;
                    align-items:center;
                    column-gap:16px;
                    .upload-item{
                        width:260px;
                        display:flex;
                        flex-direction:column;
                        align-items:center;
                        row-gap:12px;
                        cursor:pointer;
                        .img-item{
                            width:100%;
                            height:176px;
                            // border-radius:10px;
                            border:1px dashed #e3e3e3;
                            overflow:hidden;
                            position:relative;
                            .delete-ico{
                                position:absolute;
                                top:4px;
                                right:4px;
                                width:20px;
                                height:20px;
                                cursor:pointer;
                            }
                            img{
                                width:100%;
                                height:100%;
                                object-fit: cover;
                                object-position: center;
                                border-radius:10px;
                            }
                        }
                        .item-title{
                            color:#999;
                            font-size:12px;
                        }
                    }
                    ul li{
                        color:#999;
                        font-size:12px;
                        margin-left:22px;
                    }
                }
                .form-item-value-checkbox{
                    display:flex;
                    flex-wrap:wrap;
                    gap:12px;
                    .checkbox-item{
                        width:140px;
                        height:42px;
                        border:1px solid #e3e3e3;
                        border-radius:4px;
                        display:flex;
                        align-items:center;
                        padding-left:16px;
                        white-space:nowrap;
                        overflow:hidden;
                        text-overflow:ellipsis;
                        ::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
                            border-color: #ff5967;
                            background-color: #ff5967;
                        }
                    }
                }
                .form-item-value-radio{
                    display:flex;
                    align-items: center;
                    .radio-item{
                        width:100px;
                        height:42px;
                        display:flex;
                        align-items:center;
                        justify-content: center;
                        white-space:nowrap;
                        overflow:hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
        .form-agree{
            display:flex;
            align-items:center;
            column-gap:5px;
            color:#666;
            font-size:14px;
            padding-left:50px;
            margin-top:35px;
            div{
                cursor:pointer;
            }
        }
        .form-submit{
            width:100%;
            display:flex;
            align-items:center;
            justify-content:center;
            margin-top:57px;
            margin-bottom:60px;
            .submit-btn{
                width:220px;
                height:48px;
                border-radius:8px;
                background:#ff5967;
                color:#fff;
                cursor:pointer;
                font-size:16px;
                text-align:center;
                line-height:48px;
                &.disabled{
                    background:rgba(255,89,103,0.5);
                    cursor:not-allowed;
                }
            }
        }
    }
}
.form-item-col-2{
    display:flex;
    align-items:center;
    column-gap:20px;
}
.form-item-col-1{
    width:100%;
    display:flex;
    align-items:center;
}
.form-item-col-half{
    width:50%;
    display:flex;
    align-items:center;
}

::v-deep .ivu-radio-checked .ivu-radio-inner {
    border-color: rgb(255, 89, 103);
}

::v-deep .ivu-radio-focus {
    -webkit-box-shadow: 0 0 0 2px rgba(255, 89, 103, .2);
    box-shadow: 0 0 0 2px rgba(255, 89, 103, .2);
    z-index: 1;
}

::v-deep .ivu-radio-inner:after{
    background-color:#ff5967;
}

::v-deep .popup-modal {
  /* 弹窗内容区 */
  .popup-content {
    /* 修正后 */
    width: max(980px, 96vw); // 增加视口占比
    min-width: 320px; // 保障最小可操作宽度
    max-width: none !important; // 移除潜在限制

    /* 添加边距保护 */
    margin: 0 2vw; // 左右留白
    box-sizing: content-box; // 防止padding影响
    max-height: max(500px, 80vh); // 最大720px，最小占85%视口高
    min-height: 30vh;
    // height:100%;
    display: flex;
    flex-direction: column;
    .agree-content {
      overflow-y: scroll;
      height:100%;
      max-height: max(30vh, 70vh); // 最大720px，最小占85%视口高
      padding: 30px 30px 0 30px;;
      &::-webkit-scrollbar {
        width: 0px;
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 3px;
      }
    }
  }
}
</style>